import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { API_URL, authHeaders } from './utils';
import FilterBar from './FilterBar';
import '../../components/componenetStyle/ListaUrzadzen.css';
import { useAuth } from '../../auth/AuthContext';

const ListaJednostek = () => {
  const { hasPermission } = useAuth();
  const canManageWarehouse = hasPermission('warehouse_manage');
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState('active');
  const [search, setSearch] = useState('');
  const [isAdding, setIsAdding] = useState(false);
  const [newRow, setNewRow] = useState({ symbol: '', nazwa: '' });
  const [editingId, setEditingId] = useState(null);
  const [edit, setEdit] = useState({ symbol: '', nazwa: '' });

  const query = useMemo(() => {
    const q = new URLSearchParams();
    if (filter !== 'all') q.set('active', filter === 'active' ? 'true' : 'false');
    if (search.trim()) q.set('search', search.trim());
    q.set('limit', '500');
    return q.toString();
  }, [filter, search]);

  const fetchRows = async () => {
    const { data } = await axios.get(`${API_URL}/slowniki/jednostki?${query}`, { headers: authHeaders() });
    setRows(data || []);
  };

  useEffect(() => { fetchRows(); /* eslint-disable-next-line */ }, [query]);

  const saveAdd = async () => {
    if (!canManageWarehouse) return;
    if (!newRow.symbol.trim()) return alert('Podaj symbol (np. szt., h).');
    await axios.post(`${API_URL}/slowniki/jednostki`, {
      symbol: newRow.symbol.trim(),
      nazwa: newRow.nazwa?.trim() || null,
      active: true
    }, { headers: authHeaders() });
    setIsAdding(false);
    setNewRow({ symbol: '', nazwa: '' });
    fetchRows();
  };

  const beginEdit = (r) => { setEditingId(r.id); setEdit({ symbol: r.symbol, nazwa: r.nazwa || '' }); };
  const cancelEdit = () => { setEditingId(null); setEdit({ symbol: '', nazwa: '' }); };
  const saveEdit = async (id) => {
    if (!canManageWarehouse) return;
    await axios.put(`${API_URL}/slowniki/jednostki/${id}`, {
      symbol: edit.symbol?.trim(),
      nazwa: edit.nazwa?.trim() || null
    }, { headers: authHeaders() });
    cancelEdit();
    fetchRows();
  };

  const archive = async (id) => {
    if (!canManageWarehouse) return;
    if (!window.confirm('Zarchiwizować tę jednostkę?')) return;
    await axios.delete(`${API_URL}/slowniki/jednostki/${id}`, { headers: authHeaders() });
    fetchRows();
  };
  const restore = async (id) => {
    if (!canManageWarehouse) return;
    await axios.patch(`${API_URL}/slowniki/jednostki/${id}/restore`, {}, { headers: authHeaders() });
    fetchRows();
  };

  return (
    <div className="lista-urzadzen-container">
      <div className="header">
        <h2>Jednostki miary</h2>
        {canManageWarehouse ? <button className="add-button" onClick={() => setIsAdding(true)}>Dodaj nowe</button> : null}
      </div>
      <FilterBar filter={filter} setFilter={setFilter} search={search} setSearch={setSearch} />
      <table className="lista-urzadzen-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Symbol</th>
            <th>Nazwa</th>
            <th>Akcje</th>
          </tr>
        </thead>
        <tbody>
          {isAdding && (
            <tr>
              <td>Nowa</td>
              <td><input value={newRow.symbol} onChange={(e) => setNewRow((p) => ({ ...p, symbol: e.target.value }))} placeholder="np. szt., h" /></td>
              <td><input value={newRow.nazwa} onChange={(e) => setNewRow((p) => ({ ...p, nazwa: e.target.value }))} placeholder="(opcjonalnie)" /></td>
              <td />
            </tr>
          )}

          {rows.length === 0 ? (
            <tr><td colSpan="4">Brak danych</td></tr>
          ) : rows.map((r) => (
            <tr key={r.id}>
              <td>{r.id}</td>
              {editingId === r.id ? (
                <>
                  <td><input value={edit.symbol} onChange={(e) => setEdit((p) => ({ ...p, symbol: e.target.value }))} /></td>
                  <td><input value={edit.nazwa} onChange={(e) => setEdit((p) => ({ ...p, nazwa: e.target.value }))} /></td>
                  <td>
                    {canManageWarehouse ? <button onClick={() => saveEdit(r.id)}>Zapisz</button> : null}
                    {canManageWarehouse ? <button onClick={cancelEdit}>Anuluj</button> : null}
                  </td>
                </>
              ) : (
                <>
                  <td>{r.symbol}</td>
                  <td>{r.nazwa || '—'}</td>
                  <td>
                    {r.active ? (
                      <>
                        {canManageWarehouse ? <button onClick={() => beginEdit(r)}>Edytuj</button> : null}
                        {canManageWarehouse ? <button onClick={() => archive(r.id)}>Archiwizuj</button> : null}
                      </>
                    ) : (
                      canManageWarehouse ? <button onClick={() => restore(r.id)}>Przywróć</button> : null
                    )}
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {isAdding && canManageWarehouse && (
        <div className="new-device-actions">
          <button onClick={saveAdd}>Zapisz</button>
          <button onClick={() => { setIsAdding(false); setNewRow({ symbol: '', nazwa: '' }); }}>Anuluj</button>
        </div>
      )}
    </div>
  );
};

export default ListaJednostek;
